import { inject, observer } from 'mobx-react';
import * as React from 'react';
import SsoStore, { CUSTOMER_TYPE_BUSINESS } from '../stores/SsoStore';
import RouteStore from '../stores/RouteStore';
import { Spinner } from 'telia-front-react';

export interface RedirectToSegmentProps {
  ssoStore?: SsoStore;
  routeStore?: RouteStore;
  path: string;
}

@observer
class RedirectToSegment extends React.Component<RedirectToSegmentProps> {
  public redirect() {
    const { routeStore } = this.props;
    routeStore.push(this.getRedirectUrl());
  }

  private getRedirectUrl() {
    const {
      ssoStore: { customerType },
      path,
    } = this.props;
    const segment = customerType === CUSTOMER_TYPE_BUSINESS ? '/ari' : '/era';
    const pathWithoutSlashes = path.replace(/^\/|\/$/g, '');
    const queryParams = window.location.search;

    return `${segment}/${pathWithoutSlashes}${queryParams}`;
  }

  public render() {
    if (!this.props.ssoStore.initialSsoMessageReceived) {
      return <Spinner />;
    }

    this.redirect();
    return null;
  }
}

export default inject('routeStore', 'ssoStore')(RedirectToSegment);
